import { useEffect, useRef, useState } from "react";
import styles from "./HeroAbstract.module.css";

const SYMBOLS = [
  "01010101", "∑ xᵢ", "10110010", "∂f/∂x", "00101101", "∫ f(x)", "11001001", "λ ∈ ℝ",
  "∇ f(x)", "10010110", "x² + y²", "01101010", "lim x→∞", "10101100", "Σ wᵢxᵢ", "01011001",
  "11010010", "P(A|B)", "00110101", "⟨x, y⟩", "10100101", "√(x²)", "01110010", "Δx / Δt",
];

export function HeroAbstract() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  const [visible, setVisible] = useState(!document.hidden);
  const [reduced, setReduced] = useState(true);
  useEffect(() => {
    const media = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    const onMotion = () => setReduced(media?.matches ?? true);
    const onVisibility = () => setVisible(!document.hidden);
    const observer = typeof IntersectionObserver === "function" ? new IntersectionObserver(([entry]) => {
      setInView(entry.isIntersecting);
    }, { threshold: 0 }) : null;
    onMotion();
    media?.addEventListener?.("change", onMotion);
    document.addEventListener("visibilitychange", onVisibility);
    if (ref.current) observer?.observe(ref.current);
    return () => {
      observer?.disconnect();
      media?.removeEventListener?.("change", onMotion);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
  return (
    <div ref={ref} className={styles.card} data-testid="hero-abstract" data-running={inView && visible && !reduced} aria-hidden="true">
      {SYMBOLS.map((text, i) => (
        <span key={text} className={styles.symbol} style={{ "--delay": `${i * -1.7}s`, "--duration": `${7 + i % 6}s` }}>{text}</span>
      ))}
    </div>
  );
}
